<h2 mat-dialog-title>
  {{ createMode ? "Crear Propuesta" : "Detalle de Propuesta" }}
</h2>

<mat-icon
  class="editIcon"
  [ngClass] = "{ 'disable': canEdit === false }"
  *ngIf="editMode && !createMode"
  title="Modificar propuesta"
  (click)="edit()"
  >edit</mat-icon
>
<mat-icon
  class="deleteIcon"
  [ngClass] = "{ 'disable': canDelete === false }"
  *ngIf="editMode && !createMode"
  title="Eliminar propuesta"
  (click)="deleteConfirmation()"
  >delete</mat-icon
>

<mat-dialog-content>
  <form #form class="example-form">
    <!--titulo-->
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Titulo</mat-label>
      <input
        id="title"
        matInput
        [formControl]="title"
        maxlength="256"
        placeholder="Ingrese un titulo"
        required
      />
      <mat-hint *ngIf="editMode || createMode" align="start"
        ><strong></strong
      ></mat-hint>
      <mat-hint *ngIf="editMode || createMode" align="end"
        >{{ title.value.length }} / 256</mat-hint
      >
      <mat-error *ngIf="title.hasError('required') || title.hasError('whitespace')"
      >Titulo <strong>inválido</strong></mat-error
      >
    </mat-form-field>
    <!--descripcion-->
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Descripción</mat-label>
      <textarea
        id="description"
        matInput
        [formControl]="description"
        maxlength="800"
        placeholder="Ingrese una descripción"
        cdkTextareaAutosize
        cdkAutosizeMinRows="5"
        cdkAutosizeMaxRows="5"
        required
      ></textarea>
      <mat-hint *ngIf="editMode || createMode" align="start"
        ><strong></strong
      ></mat-hint>
      <mat-hint *ngIf="editMode || createMode" align="end"
        >{{ description.value.length }} / 800</mat-hint
      >
      <mat-error *ngIf="description.hasError('required') || description.hasError('whitespace')"
      >Descripción <strong>inválida</strong></mat-error
      >
    </mat-form-field>

    <mat-list-item *ngIf="!createMode && proposal.showUserProposer">Propuesto por: {{ proposal.userName }}</mat-list-item>
    <mat-list-item *ngIf="createMode">Propuesto por: {{ newProposalUserName }}</mat-list-item>

    <mat-form-field appearance="outline">
      <mat-label>Categorias</mat-label>
      <mat-select
        [formControl]="category"
        name="category"
        [errorStateMatcher]="matcher"
        required
      >
        <mat-option *ngFor="let category of categories" [value]="category.id">
          {{ category.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    *ngIf="editMode || createMode"
    [disabled]="!formGroup.valid || !formGroup.dirty || disable"
    mat-raised-button
    color="primary"
    (click)="onSubmit()"
  >
    {{ this.editMode ? "Guardar" : "Crear" }}
  </button>
  <button mat-button color="primary" (click)="onClose()">
    {{ editMode ? "Cancelar" : "Cerrar" }}
  </button>
</mat-dialog-actions>
